import { takeEvery, call, put, all, takeLatest } from 'redux-saga/effects';
import { payments, loading, toast, modal, serviceRequest } from '../types';
import iceberg_apis from '../iceberg_apis';
import scogo_apis from '../scogo_apis';
import { uploadFileToS3WithSignedUrlNew } from '../utils/common';


export function* getAllWithdrawalTransactions(action) {
    const { limit, page, query, payload } = action.payload;

    let queryParams = { limit, page };
    if (query) queryParams.q = query;
    if (payload && Object.keys(payload).length > 0) queryParams = { ...queryParams, ...payload };
    try {
        yield put({ type: loading.SET_ALL_WITHDRAWAL_TRANSACTIONS_LOADING, payload: true });
        const response = yield call(iceberg_apis.transactions.getListTransaction, {}, {}, queryParams, {});
        if (response.status === 200) {
            yield put({ type: payments.GET_ALL_WITHDRAWAL_TRANSACTIONS_SUCCESS, payload: response.data });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: response.data.data.message } });
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.SET_ALL_WITHDRAWAL_TRANSACTIONS_LOADING, payload: false });
    }
}


export function* getInvoices(action) {
    const { limit, page, query, payload } = action.payload;
    let queryParams = { limit, page };
    if (query) queryParams.q = query;
    if (payload && Object.keys(payload).length > 0) queryParams = { ...queryParams, ...payload };
    try {
        yield put({ type: loading.SET_INVOICES_LOADING, payload: true });
        const response = yield call(scogo_apis.invoice.get, {}, {}, queryParams, {});
        if (response.status === 200) {
            yield put({ type: payments.GET_INVOICES_SUCCESS, payload: response.data });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: response.data.data.message } });
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.SET_INVOICES_LOADING, payload: false });
    }
}


export function* createPo(action) {
    const { payload, formName, navigate } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.create, {}, {}, {}, payload);
        if (response.status === 201) {
            yield all([
                put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PO Created Successfully' } }),
                put({ type: modal.CLOSE_MODAL }),
            ]);
            navigate(-1);
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
};


export function* listPO(action) {
    const { limit, page, query, payload } = action.payload;
    let queryParams = { limit, page };
    if (query) queryParams.q = query;
    if (payload && Object.keys(payload).length > 0) queryParams = { ...queryParams, ...payload };

    try {
        yield put({ type: loading.SET_PO_LOADING, payload: true });
        const response = yield call(scogo_apis.po.list, {}, {}, queryParams, {});
        if (response.status === 200) {
            yield put({ type: payments.LIST_PO_SUCCESS, payload: response.data });
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.SET_PO_LOADING, payload: false });
    }

};

export function* getPoById(action) {
    const { id } = action.payload;
    try {
        yield put({ type: loading.GET_PO_BY_ID_LOADING, payload: true });
        const response = yield call(scogo_apis.po.getById, {}, { id }, {}, {});
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_BY_ID_SUCCESS, payload: response.data });
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.GET_PO_BY_ID_LOADING, payload: false });
    }

}

export function* updatePoById(action) {
    const { id, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.update, {}, { id }, {}, payload);
        if (response.status === 200) {
            yield all([
                put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PO Updated Successfully' } }),
                put({ type: modal.CLOSE_MODAL }),
                put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } }),
            ]);
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* deletePoById(action) {
    const { id, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.delete, {}, { id }, {}, {});
        if (response.status === 200) {
            yield all([
                put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PO Deleted Successfully' } }),
                put({ type: modal.CLOSE_MODAL }),
                put({ type: payments.LIST_PO_REQUEST, payload: { limit: 10, page: 1, payload: {} } })
            ]);
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}
export function* deletePoPurgeById(action) {
    const { id, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.deletePurge, {}, { id }, {}, {});
        if (response.status === 200) {
            yield all([
                put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PO Deleted Successfully' } }),
                put({ type: modal.CLOSE_MODAL }),
            ]);
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


export function* poCancellationRequest(action) {
    const { id, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.cancel, {}, { id }, {}, payload);
        if (response.status === 201) {
            yield all([
                put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PO Cancelled Successfully' } }),
                put({ type: modal.CLOSE_MODAL }),
                yield put({ type: payments.LIST_PO_REQUEST, payload: { limit: 10, page: 1, payload: {} } }),
            ]);
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


export function* addLineItemsToPO(action) {
    const { id, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.addLineItems, {}, { id }, {}, payload);
        if (response.status === 201) {
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Line Items Added to PO' } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: response.data.data.message || 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* deleteLineItemsToPO(action) {
    const { id, itemId, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.deleteLineItems, {}, { id, itemId }, {}, {});
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Line Items Deleted from PO' } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: response.data.data.message || 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


// export function* refreshPaymentsPage(action) {
//     const { tab, enduserId } = action.payload;
//     yield put({ type: payments.REFRESH_PAYOUTS_PAGE, payload: { tab, enduserId } });
// }

export function* payToVendorsWallet(action) {
    const { id, itemId, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.payToVendorsWallet, {}, { id, itemId }, {}, payload);
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: payments.PAY_TO_VENDORS_WALLET_SUCCESS, payload: response.data });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Payment Made Successfully' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* payToVendorsBank(action) {
    const { id, itemId, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.payToVendorsBank, {}, { id, itemId }, {}, payload);
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: payments.PAY_TO_VENDORS_BANK_SUCCESS, payload: response.data });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Payment Made Successfully' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* payManually(action) {
    const { id, itemId, payload, formName } = action.payload;

    try {
        const body = { remark: payload.remark };


        if (payload.file) {
            const requestBody = {
                files: [{
                    name: payload.file.name,
                    mime_type: payload.file.type,
                    size: payload.file.size
                }],
                purpose: 'TICKET_ADDITIONAL_PAYMENT_PROOF',
                milestone_id: "ticketmilestone_2unqu95tZ06TlLYH7T6oLFKirGi",
                ticket_id: "ticket_2unquBMianV9wCgOTKaHpb2W6Uw"
            };
            const signedUrl = yield call(scogo_apis.user.postImageUrl, {}, {}, {}, requestBody);
            if (signedUrl.status !== 201) throw new Error('Failed to get signed URL');
            const fileData = signedUrl?.data?.data?.postUrls[0];


            const fileUploadBody = {
                'Content-Type': fileData.mimeType,
                'key': fileData.payload.key,
                ...(fileData.payload.acl ? { 'acl': fileData.payload.acl } : {}),
                'X-Amz-Date': fileData.payload.date,
                'X-Amz-Algorithm': fileData.payload.algorithm,
                'x-amz-meta-uuid': fileData.payload.uuid,
                'X-Amz-Credential': fileData.payload.credential,
                'Policy': fileData.payload.policy,
                'X-Amz-Signature': fileData.payload.signature,

            };

            if (fileData.fileUrl) {
                body.attachments = [fileData.fileUrl];
            }
            try {
                uploadFileToS3WithSignedUrlNew(fileData.postUrl, payload.file, fileUploadBody);
                console.log(`File uploaded successfully: ${payload.file.name}`);
            } catch (uploadError) {
                console.error(`Error uploading file ${payload.file.name}:`, uploadError);
            }
        }
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.payManually, {}, { id, itemId }, {}, body);
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: payments.PAY_MANUALLY_SUCCESS, payload: response.data });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Payment Made Successfully' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


export function* editLineItemsToPO(action) {
    const { id, itemId, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.editLineItems, {}, { id, itemId }, {}, payload);
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Line Items Updated Successfully' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* updatePoStatus(action) {
    const { id, payload, formName } = action.payload;

    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.approveOrRejectPo, {}, { id }, {}, payload);
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: modal.CLOSE_FULL_SCREEN_MODAL });
            // yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PO Status Updated Successfully' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


export function* addApproversToPO(action) {
    const { id, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.addApprovers, {}, { id }, {}, payload);
        if (response.status === 201) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Approvers Added Successfully' } });
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
};


export function* deleteApproversFromPO(action) {
    const { id, levelId, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.deleteApprovers, {}, { id, levelId }, {}, {});
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Approvers Deleted Successfully' } });
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


export function* payTaxWallet(action) {
    const { id, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.payTaxWallet, {}, { id }, {}, payload);
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: modal.CLOSE_MODAL });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* payTaxBank(action) {
    const { id, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.payTaxBank, {}, { id }, {}, payload);
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_BY_ID_REQUEST, payload: { id } });
            yield put({ type: modal.CLOSE_MODAL });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* createInvoice(action) {
    const { payload, formName, refresh = false } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.invoice.create, {}, {}, {}, payload);
        if (response.status === 201) {
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Invoice Created Successfully' } });
            if (refresh) {
                yield put({ type: serviceRequest.REFRESH_SERVICE_REQUEST_REQUEST });
                yield put({ type: serviceRequest.REFRESH_BILLING_REMARKS_REQUEST });
            }
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


export function* getPoFilterList(action) {
    try {
        yield put({ type: loading.SET_PO_FILTERLIST_LOADING, payload: true });
        const response = yield call(scogo_apis.po.filterList, {}, {}, {}, {});
        if (response.status === 200) {
            yield put({ type: payments.GET_PO_FILTER_LIST_SUCCESS, payload: response.data });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.SET_PO_FILTERLIST_LOADING, payload: false });
    }
}

export function* getInvoicesFilterList(action) {
    try {
        yield put({ type: loading.SET_INVOICES_FILTERLIST_LOADING, payload: true });
        const response = yield call(scogo_apis.invoice.filterList, {}, {}, {}, {});
        if (response.status === 200) {
            yield put({ type: payments.GET_INVOICES_FILTER_LIST_SUCCESS, payload: response.data });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.SET_INVOICES_FILTERLIST_LOADING, payload: false });
    }
}

export function* getApprovalTemplates(action) {
    try {
        yield put({ type: loading.SET_GET_APPROVAL_TEMPLATES_LOADING, payload: true });
        const response = yield call(iceberg_apis.approval_templates.get, {}, {}, action.payload, {});
        if (response.status === 200) {
            let user_ids = [];
            let team_ids = [];
            response.data.data.forEach(template => {
                template.levels.forEach(level => {
                    if (level.user_ids && level.user_ids.length > 0) {
                        user_ids.push(...level.user_ids);
                    }
                    if (level.team_id) {
                        team_ids.push(level.team_id);
                    }
                });
            });
            let user_response = { data: { data: [] } };
            let team_response = { data: { data: [] } };

            if (user_ids.length > 0) {
                user_response = yield call(scogo_apis.user.getUsersList, {}, {}, { id: user_ids.join(',') }, {});
            }
            if (team_ids.length > 0) {
                team_response = yield call(scogo_apis.teams.getTeams, {}, {}, { id: team_ids.join(',') }, {});
            }
            let dataToSave = response.data.data;
            dataToSave.forEach(template => {
                template.levels.forEach(level => {
                    if (level.user_ids && level.user_ids.length > 0) {
                        level.users = user_response.data.data.filter(user => level.user_ids.includes(user.id)).map((user) => ({
                            id: user.id,
                            key: user.id,
                            value: user.id,
                            label: user.full_name,
                        }));
                    }
                    if (level.team_id) {
                        level.team = team_response.data.data.find(team => team.id === level.team_id);
                        if (level.team) {
                            level.team = {
                                id: level.team.id,
                                key: level.team.id,
                                value: level.team.id,
                                label: level.team.name,
                            };
                        }
                    }
                });
            });
            yield put({ type: payments.GET_APPROVAL_TEMPLATE_LIST_SUCCESS, payload: { org_id: action.payload.org_id, data: dataToSave } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.SET_GET_APPROVAL_TEMPLATES_LOADING, payload: false });
    }
}


export function* generateQuotationPdf(action) {
    const { poId, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.generateQuotationPdf, {}, { id: poId }, {}, {});
        console.log('response:', response)
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PDF Generated Successfully' } })
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* generateApprovedPdf(action) {
    const { poId, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.po.generateApprovedPdf, {}, { id: poId }, {}, {});
        console.log('response:', response)
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PDF Generated Successfully' } })
        }

    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }

}

export default function* paymentSaga() {
    yield takeEvery(payments.GET_ALL_WITHDRAWAL_TRANSACTIONS_REQUEST, getAllWithdrawalTransactions);
    yield takeEvery(payments.GET_INVOICES_REQUEST, getInvoices);
    yield takeEvery(payments.CREATE_PO_REQUEST, createPo);
    yield takeEvery(payments.LIST_PO_REQUEST, listPO);
    yield takeEvery(payments.GET_PO_BY_ID_REQUEST, getPoById);
    yield takeEvery(payments.UPDATE_PO_REQUEST, updatePoById);
    yield takeEvery(payments.DELETE_PO_BY_ID_REQUEST, deletePoById);
    yield takeEvery(payments.DELETE_PO_PURGE_REQUEST, deletePoPurgeById);
    yield takeEvery(payments.PO_CANCELLATION_REQUEST, poCancellationRequest);
    yield takeLatest(payments.ADD_LINE_ITEMS_TO_PO_REQUEST, addLineItemsToPO);
    yield takeLatest(payments.DELETE_LINE_ITEMS_TO_PO_REQUEST, deleteLineItemsToPO);
    yield takeLatest(payments.PAY_TO_VENDORS_WALLET_REQUEST, payToVendorsWallet);
    yield takeLatest(payments.PAY_TO_VENDORS_BANK_REQUEST, payToVendorsBank);
    yield takeLatest(payments.PAY_MANUALLY_REQUEST, payManually);
    yield takeLatest(payments.EDIT_LINE_ITEMS_TO_PO_REQUEST, editLineItemsToPO);
    yield takeLatest(payments.UPDATE_PO_STATUS_REQUEST, updatePoStatus);
    yield takeLatest(payments.ADD_APPROVERS_TO_PO_REQUEST, addApproversToPO);
    yield takeLatest(payments.DELETE_APPROVERS_FROM_PO_REQUEST, deleteApproversFromPO);
    yield takeLatest(payments.PAY_TAX_WALLET_REQUEST, payTaxWallet);
    yield takeLatest(payments.PAY_TAX_BANK_REQUEST, payTaxBank);
    yield takeLatest(payments.CREATE_INVOICE_REQUEST, createInvoice);
    yield takeLatest(payments.GET_PO_FILTER_LIST_REQUEST, getPoFilterList);
    yield takeLatest(payments.GET_INVOICES_FILTER_LIST_REQUEST, getInvoicesFilterList);
    yield takeLatest(payments.GET_APPROVAL_TEMPLATE_LIST_REQUEST, getApprovalTemplates);
    yield takeLatest(payments.GENERATE_QUOTATION_PDF_REQUEST, generateQuotationPdf);
    yield takeLatest(payments.GENERATE_APPROVED_PDF_REQUEST, generateApprovedPdf);
}
